<template>
  <div id="app">
    <HeaderBar/>
    <div class="columns is-gapless">
      <div class="column is-narrow is-hidden-mobile">
        <SideBar2/>
      </div>
      <div class="column">
        <router-view class="desktop-max-width"/>
      </div>
    </div>
    <div class="is-hidden-tablet">
      <FooterBar/>
    </div>
  </div>
</template>

<style lang="scss">
$fa-font-path: '~font-awesome/fonts/';
@import '~font-awesome/scss/font-awesome';

.desktop-max-width {
  margin-left: auto;
  margin-right: auto;
  max-width: 1300px;
}
</style>

<script>
import HeaderBar from '@/components/HeaderBar.vue'
import FooterBar from '@/components/FooterBar.vue'
import SideBar2 from '@/components/SideBar2.vue'

export default {
  name: 'app',
  components: {
    HeaderBar,
    FooterBar,
    SideBar2
  }
}
</script>